const BASE_PATH = '/external'

export const GITHUB_LINK = 'https://github.com/nilaysondagar'

export const externalLinks = [
    {
        label: 'LinkedIn',
        link: 'https://www.linkedin.com/in/nilay-s-36a282124/',
        imgSrc: `${BASE_PATH}/linkedin-logo.webp`,
    },
    {
        label: 'GitHub',
        link: GITHUB_LINK,
        imgSrc: `${BASE_PATH}/github-logo.webp`,
    },
    {
        label: 'Resume',
        imgSrc: `${BASE_PATH}/resume-icon.webp`,
        downloadPath: `${BASE_PATH}/nilay-sondagar-resume.pdf`,
    },
]
